/* global $ */
export default {
    navigation: true,
    responsive: true,
    responsiveRefreshRate: 200,
    responsiveBaseElement: window,
    slideSpeed: 200,
    addClassActive: true,
    paginationSpeed: 200,
    rewindSpeed: 200,
    singleItem: true,
    autoPlay: false,
    transitionStyle: 'fade',
    afterAction: function(elem) {
        $('.active .tlt').textillate('start');
    },
    navigationText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
    ],
};



// WEBPACK FOOTER //
// ./src/pages/home/components/videoIntro/carouselOptions.js